<template >
  <SlDialog title="多货标签下单" :visible.sync="dialogVisible" width="800px" @closed="handleClose">
    <el-form
      ref="moreStockLabelFormRef"
      :model="moreStockLabelForm"
      :validate-on-rule-change="false"
      label-width="100px"
      inline
    >
      <SlTable
        align="center"
        :border="true"
        :tableData="tableData"
        :columns="columns"
        :selection="false"
        :operate="false"
        :tooltip="false"
        :isEmbedTable="true"
        class="label-order-table"
      >
        <div slot="requireEpcQuantity" slot-scope="{row, index}">
          <span v-if="onlyView">{{ row.requireEpcQuantity }}</span>
          <el-form-item label-width="0px" :prop="`items.${index}.requireEpcQuantity`" v-else>
            <el-input
              v-model="moreStockLabelForm.items[index].requireEpcQuantity"
              v-slFormatNumber="{ type: 'integer', max: 999999, compareLength: false, includeZero: false }"
              placeholder=">0"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </SlTable>
    </el-form>

    <div class="address-box" v-if="canEditLabelAddress">
      <div class="flex1">
        <div>收货信息</div>
        <div>收货地址：{{address.consigneeAddress || '-'}}</div>
        <div>收货姓名：{{address.consigneeName || '-'}}</div>
        <div>收货电话：{{address.consigneeNumber || '-'}}</div>
      </div>
      <div>
        <el-button
          type="text"
          @click="handleUpdateAddress"
        >{{address.consigneeAddress ? '编辑' : '新增'}}地址</el-button>
      </div>
    </div>

    <UpdateAddressDialog
      :address="address"
      :visible.sync="updateAddressDialogVisible"
      @submitSuccess="handleUpdateAddressSuccess"
    ></UpdateAddressDialog>

    <span slot="bottom" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('button.cancelText') }}</el-button>
      <el-button
        type="primary"
        v-if="!onlyView"
        :loading="submitLoading"
        :disabled="submitLoading"
        @click="handleSubmit"
      >{{ $t('button.enterText') }}</el-button>
    </span>
  </SlDialog>
</template>

<script>
import OemGoodsAPI from '@api/oemGoods'
import UpdateAddressDialog from './UpdateAddressDialog.vue'

export default {
  name: 'MoreStockLabelOrderDialog',
  components: { UpdateAddressDialog },
  props: {
    visible: {
      type: Boolean,
      default: false,
      required: true
    },
    selectedRow: {
      type: Object,
      default: () => { },
      required: true
    },
    // 是否只读
    onlyView: {
      type: Boolean,
      default: true,
      required: true
    },
    initAddress: {
      type: Object,
      default: () => { },
      required: false
    }
  },
  data () {
    return {
      dialogVisible: false,
      submitLoading: false,
      moreStockLabelForm: {
        items: []
      },
      tableData: [],
      columns: [
        {
          prop: 'productName',
          label: '产品名称'
        },
        {
          prop: 'skuCode',
          label: 'SKU'
        },
        {
          prop: 'upc',
          label: 'UPC'
        },
        {
          prop: 'requireQuantity',
          label: '订单数量'
        },
        {
          prop: 'requireEpcQuantity',
          label: '多货标签下单数量',
          width: '200'
        }
      ],
      address: {
        consigneeAddress: '',
        consigneeName: '',
        consigneeNumber: ''
      },
      updateAddressDialogVisible: false
    }
  },
  watch: {
    visible: {
      handler: function (newVal) {
        if (this.dialogVisible !== newVal) {
          this.dialogVisible = newVal
        }
      },
      immediate: true
    },
    selectedRow: {
      handler: function (newVal) {
        const { id } = newVal || {}
        if (!id) return
        if (this.onlyView) {
          this.initTableByApi(newVal)
        } else {
          this.initTable(newVal)
        }
      },
      immediate: true,
      deep: true
    },
    initAddress: {
      handler: function (newVal) {
        const { consigneeAddress = '', consigneeName = '', consigneeNumber = '' } = newVal || {}
        this.address = { consigneeAddress, consigneeName, consigneeNumber }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    canEditLabelAddress () {
      const { canEditLabelAddress } = this.selectedRow
      return canEditLabelAddress || ''
    }
  },
  methods: {
    initTableByApi (row) {
      const { id = '' } = row

      OemGoodsAPI.getMoreStockLabelOrder(id).then(res => {
        let { success, data = [] } = res
        if (success) {
          this.tableData = data || []
        }
      })
    },
    initTable (row) {
      const { skuList = [] } = row || {}
      this.tableData = skuList || []

      this.moreStockLabelForm.items = (skuList || []).map(item => {
        const { skuCode = '' } = item || {}
        return {
          skuCode,
          requireEpcQuantity: ''
        }
      })
    },
    handleSubmit () {
      const submitItems = (this.moreStockLabelForm.items || []).filter(item => item.requireEpcQuantity)
      if (submitItems.length === 0) {
        this.$message.error('请至少填写一条数据')
        return
      }

      this.submitLoading = true
      const { id = '' } = this.selectedRow
      OemGoodsAPI.moreStockCreateLabelOrder(id, this.moreStockLabelForm.items).then(res => {
        let { success } = res
        if (success) {
          this.$message.success('操作成功')

          this.resetData()
          this.dialogVisible = false
          this.$emit('update:visible', false)
          this.$emit('submitSuccess', false)
        }
      }).finally(() => {
        this.submitLoading = false
      })
    },
    handleClose () {
      this.resetData()
      this.dialogVisible = false
      this.$emit('update:visible', false)
    },
    resetData () {
      this.tableData = []
      this.moreStockLabelForm = {
        items: []
      }
    },
    handleUpdateAddress () {
      this.updateAddressDialogVisible = true
    },
    handleUpdateAddressSuccess (newAddress) {
      this.address = { ...newAddress }
    }
  }
}
</script>

<style lang="scss" scoped>
.label-order-table {
  /deep/ .el-table__body-wrapper {
    max-height: 50vh;
    overflow-y: scroll;
  }
}

.address-box {
  margin-top: 40px;
  display: flex;
  align-items: flex-start;
  .flex1 {
    flex: 1;
    div {
      margin-bottom: 10px;
    }
  }
  .address-title {
    font-weight: 500;
  }
}
</style>
